// extracted by mini-css-extract-plugin
module.exports = {"contact-check":"PersonDetails_contact-check__ZNCmw","form-info":"PersonDetails_form-info__rQk88","icon":"PersonDetails_icon__eeVFV","desc":"PersonDetails_desc__0lvKE"};